module.exports = __webpack_public_path__ + "static/img/video-cover.460604fa.png";